/**
 * @file ManifestValidator.ts
 * @description Manifest 运行时校验工具。
 * 这里做外部输入的基础防御，避免错误 manifest 在扫描阶段产生隐蔽异常。
 */

import type { DeviceManifest } from '../types/manifest'
import { isFiniteNumber } from '../utils/guards'

/**
 * 校验 manifest 的硬件识别字段是否足够创建扫描过滤器。
 */
export function validateManifestHardware(manifest: DeviceManifest): string[] {
  const errors: string[] = []

  if (!isFiniteNumber(manifest.hardware?.vendorId)) {
    errors.push(`${manifest.model}: hardware.vendorId 必须是数字`)
  }

  const productIds = Array.isArray(manifest.hardware?.productId)
    ? manifest.hardware.productId
    : [manifest.hardware?.productId]

  if (productIds.some((pid) => !isFiniteNumber(pid))) {
    errors.push(`${manifest.model}: hardware.productId 必须是数字或数字数组`)
  }

  return errors
}
